/**
 * Created by Christof Sander on 28.09.2016.
 */
const utils = require('../../../lib/utils')

module.exports = {
	config: {
		jsonEditorOptions: {
			mode: 'code'
		},
		focusAble: true,
		focusPriority: 501
	},

	// editor instance of jsonEditor
	_editor: null,

	events: {
		/**
		 * this function handles the Escape and Enter key-down-events
		 */
		keyboard: {
			type: 'keydown',
			action: function (event) {
				switch (utils.keyboard.getKeyCode(event)) {
					case 'enter':
					case 'esc':
						event.stopImmediatePropagation();
						break;
				}
			}
		}
	},

	methods: {
		/**
		 * this function is used save the editors' data within this components' model.
		 */
		data2Model: function(){
			if(utils.isEmpty(this._editor.getText())){
				this.model.dataJSON = null;
			}
			else {
				this.model.dataJSON = this._editor.get();
			}
		},

		/**
		 * this function is used to return the actual editors content
		 *
		 * @returns json
		 */
		getEditorContent: function(){
			this.data2Model();
			return this.model.dataJSON;
		}
	},

	hooks: {
		attach: function($element, options){
			// it should not be important where the data source is located
			if(this.resourceData && !this.model.dataJSON) this.model.dataJSON = this.resourceData;

			// create the editor
			// NOTE: if the JSONEditor has not been loaded (e.g., for non-root users) this script should not break.
			try {
				this._editor = new JSONEditor(
					$element[0],
					this.config.jsonEditorOptions,
					this.model.dataJSON
				);

				// set focus on jsonEditor
				this._editor.focus();
			} catch(error) {
				console.error(error);
			}
		}
	}
};